import React from 'react';
import { CtaButton } from '../CtaButton';
import { TrustRow } from '../TrustRow';
import { MOCKUP_URL } from '../../data/content';
export function FinalCloseSection() {
  return <section id="final" className="relative overflow-hidden bg-brand-night px-5 py-14 text-center text-white sm:py-20" data-id="element-54" data-mp="39epz05cur92b">
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-[38%] h-[380px] w-[700px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-brand-violet/20 blur-[120px]" data-id="element-55" data-mp="34gesa3huteob" />
      <div className="relative mx-auto max-w-4xl" data-id="element-56" data-mp="zzci7b54g5e">
        <h2 className="font-display text-3xl font-bold leading-tight tracking-tight sm:text-4xl lg:text-5xl" data-id="element-57" data-mp="11aga74l5nwi">
          Your Next Reading Doesn't Have to Start From a Blank Page.
        </h2>

        <img src={MOCKUP_URL} alt="The complete Astrologer Ready bundle" loading="lazy" className="mx-auto mt-8 w-full max-w-3xl object-contain drop-shadow-[0_30px_60px_rgba(0,0,0,0.55)]" data-id="element-58" data-mp="3ncoeje2wtbje" />

        <div className="mx-auto mt-8 max-w-2xl space-y-4 text-base leading-relaxed text-white/80 sm:text-lg" data-id="element-59" data-mp="1h3zjm08vh6p2">
          <p data-id="element-60" data-mp="1m2aso8rcfd68">
            You already have the astrology knowledge.{' '}
            <strong className="font-black text-white" data-id="element-61" data-mp="18c7gybq3b1v1">Astrologer Ready gives you the system.</strong>
          </p>
          <p data-id="element-62" data-mp="1ccrbd7ja3rdh">
            Prepare faster. Know what to prioritize. Organize complex information. Communicate more clearly. Walk into your sessions with a professional framework already in place.
          </p>
        </div>

        <p className="mt-10 text-sm font-black uppercase tracking-[0.14em] text-brand-lilac sm:text-base" data-id="element-63" data-mp="13dnpxwwn2zvt">
          6 Core Volumes + 5 Premium Bonuses
        </p>
        <CtaButton label="Yes — Give Me Instant Access" showGuarantee className="mt-7" data-id="element-64" data-mp="te57jkwdnm5v" />
        <TrustRow variant="final" data-id="element-65" data-mp="2jrdwrbf58295" />

        <p className="mt-8 font-display text-xl font-bold text-white sm:text-2xl" data-id="element-66" data-mp="2jsfkafdcih7r">
          Stop improvising your readings. Get Astrologer Ready.
        </p>
      </div>
    </section>;
}